import { httpClient } from "../../../shared/api/httpClient"
import type {
    ReiniciarContraseniaRequest,
    UsuarioSimpleResult,
} from "../types/usuarios.types"

export const usuarioCambiarContrasenia = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ActualizarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioReiniciarContraseña = async (dataPOST: ReiniciarContraseniaRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ReiniciarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
export const mostrarFoto = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/MostrarFoto", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
export const actualizarFoto = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ReiniciarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
